import React from 'react'

import MetaTags from 'components/meta/MetaTags'
import ScrollTop from 'components/utils/ScrollTop'
import {
  Container,
  PageCTALink,
  ResponsiveTwoColumnLayout,
  SpacedColumn,
} from 'components/landing/display'
import { useGetCustomerReferralQuery } from 'hooks/useQueries'
import { useParams } from 'react-router'
import Loading from 'components/display/Loading'
import { HeadingLg, ParagraphSm } from 'components/display/Typography'
import styled from 'styled-components'
import SimpleA from 'components/display/SimpleAnchor'
import HelpCard from 'components/cards/HelpCard'
import isEmpty from 'lodash/isEmpty'
import Header from './Header'
import Message from './Message'
import Voucher from './Voucher'

const MessageWrapper = styled.div`
  width: 100%;
`

const VoucherWrapper = styled.div`
  width: 100%;

  ${HeadingLg} {
    margin-top: 24px;
    text-align: center;
    color: ${({ theme }) => theme?.['-ds-core-400']?.value};
  }
`

const Referral = () => {
  const { token } = useParams() as { token: string }
  const { data, loading } = useGetCustomerReferralQuery({
    variables: { token },
  })

  if (loading) {
    return <Loading />
  }

  const referral = data?.customerReferral

  return (
    <>
      <ScrollTop />
      <MetaTags
        title={`It's time to live fully, ${referral.recipientFirstName}`}
      />
      <Header referral={referral} />

      <Container style={{ marginTop: 60 }}>
        <ResponsiveTwoColumnLayout gutter="120px">
          {!isEmpty(referral.message) && (
            <SpacedColumn>
              <MessageWrapper>
                <ParagraphSm>Here&apos;s what they had to say:</ParagraphSm>
                <Message referral={referral} />
              </MessageWrapper>
            </SpacedColumn>
          )}
          <SpacedColumn>
            <VoucherWrapper>
              <ParagraphSm>
                Use your voucher code below when booking your first escape, and
                we&apos;ll send {referral.referrer.firstName} a voucher too once
                your booking is complete.
              </ParagraphSm>
              <HeadingLg>Your unique voucher code</HeadingLg>
              <Voucher voucher={referral.referralVoucher} />
              <ParagraphSm>
                Simply add your voucher when you&apos;re booking your first
                escape.
              </ParagraphSm>
              <ParagraphSm weight="400">
                <SimpleA href="/redeem" textDecoration="none">
                  Learn more about redeeming vouchers.
                </SimpleA>
              </ParagraphSm>
            </VoucherWrapper>
          </SpacedColumn>
        </ResponsiveTwoColumnLayout>
      </Container>
      <Container>
        <HelpCard>
          <PageCTALink
            info={
              <ParagraphSm>
                Ready to get started? Check out our stories to find your first
                adventure.
              </ParagraphSm>
            }
            href="/stories"
          >
            Explore Stories
          </PageCTALink>
        </HelpCard>
        <ParagraphSm weight="400" centered style={{ marginTop: 40 }}>
          <SimpleA
            href="https://help.riparide.com/en/articles/8184990-refer-a-friend-program"
            target="_blank"
            textDecoration="none"
          >
            Learn more about how referrals work on Riparide.
          </SimpleA>
        </ParagraphSm>
      </Container>
    </>
  )
}

export default Referral
